import { AppEnvironment } from './environment.model';

export const environmentBase: AppEnvironment = {
  unitSelector: false,
  unitSelectorDefault: 'METRIC',
  domain: 'ERIKORGU',
  brand: 'Fitcat',
  customURL: 'erikorgu://',
  production: true,
  isCordova: false,
  ABSOLUTE_PATH: '',
  STRIPE_PUBLIC_KEY: null,
  BANKLINK_PUBLIC_KEY: '33FsXjKtxxkCeYQcRcPccOHullNLWxvh',
  INTERCOM_APP_ID: 'xl2ytfu6',
  INTERCOM_APP_ID_IOS: null,
  INTERCOM_APP_ID_ANDROID: null,
  BASE_HREF: '/',
  passwordLoginEnabled: true,
  lang: 'et_EE',
  langShort: 'ET',
  adwordsPurchase: null,
  currencyCode: 'EUR',
  currencySymbol: '€',
  languages: ['en_GB'],
  misc: {
    supportEmail: 'info@fitcat.com',
  },
  minAmount: 899,
};
